<table mat-table [dataSource]="dataSource!" matSort class="mat-elevation-z8">

    <ng-container matColumnDef="lineDescription">
        <th mat-header-cell *matHeaderCellDef>Standort </th>
        <td mat-cell *matCellDef="let element"> {{element.lineDescription ? element.lineDescription : "---" }} </td>
    </ng-container>

    <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef> SST </th>
        <td mat-cell *matCellDef="let element"> {{element.deviceName}} </td>
    </ng-container>
    <ng-container matColumnDef="measuredAt">
        <th mat-header-cell *matHeaderCellDef> Zeit (von) </th>
        <td mat-cell *matCellDef="let element"> {{element.timestampFrom | date: 'dd.MM.yyyy - H:mm' }} </td>
    </ng-container>

    <ng-container matColumnDef="digitalInputActive1">
        <th mat-header-cell *matHeaderCellDef> {{ digitalInput1Name ? digitalInput1Name : "Eingang 1" }}</th>
        <td mat-cell *matCellDef="let element"> {{element.channelStatus[1] ? element.channelStatus[1] : "---"}} </td>
    </ng-container>

    <ng-container matColumnDef="digitalInputActive2">
        <th mat-header-cell *matHeaderCellDef> {{ digitalInput2Name ? digitalInput2Name : "Eingang 2" }}</th>
        <td mat-cell *matCellDef="let element"> {{element.channelStatus[2] ? element.channelStatus[2] : "---"}} </td>
    </ng-container>

    <ng-container matColumnDef="digitalInputActive3">
        <th mat-header-cell *matHeaderCellDef> {{ digitalInput3Name ? digitalInput3Name : "Eingang 3" }}</th>
        <td mat-cell *matCellDef="let element"> {{element.channelStatus[3] ? element.channelStatus[3] : "---"}} </td>
    </ng-container>

    <ng-container matColumnDef="digitalInputActive4">
        <th mat-header-cell *matHeaderCellDef> {{ digitalInput4Name ? digitalInput4Name : "Eingang 4" }} </th>
        <td mat-cell *matCellDef="let element"> {{element.channelStatus[4] ? element.channelStatus[4] : "---"}} </td>
    </ng-container>
    <ng-container matColumnDef="digitalOutputActive1">
        <th mat-header-cell *matHeaderCellDef> {{ digitalOutput1Name ? digitalOutput1Name : "Ausgang 2" }} </th>
        <td mat-cell *matCellDef="let element"> {{element.channelStatus[7] ? element.channelStatus[7] : "---"}} </td>
    </ng-container>
    <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef> Dauer </th>
        <td mat-cell *matCellDef="let element"> {{element.duration }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>